export const piiChecks = {
  email:
    /\b[a-zA-Z0-9](?:[a-zA-Z0-9._-]{0,63}[a-zA-Z0-9])?@[a-zA-Z0-9](?:[a-zA-Z0-9.-]{0,251}[a-zA-Z0-9])?\.\w{2,4}\b/i,
  address:
    /^(\d{1,6})\s+([a-zA-Z]+(?:\s+[a-zA-Z]+){0,5})\s+(court|ct|street|st|drive|dr|lane|ln|road|rd|boulevard|blvd|circle|cir|trail|trl|crossing|xing|place|pl|avenue|ave|cove|cv|trace|trce|manor|mnr|way|loop|bend|bnd|landing|lndg|path|parkway|pkwy|pass|ridge|rdg|view|vw)(?:\s*,\s*([a-zA-Z]+(?:\s+[a-zA-Z]+){0,3}))?(?:\s*,\s*([a-zA-Z.]+(?:\s+[a-zA-Z.]+){0,3}))?(?:\s*,\s*(\d{4}))?(?:\s*,\s*([a-zA-Z]+(?:\s+[a-zA-Z]+){0,2}))?$/i,
  // phone: /^(\+?\(61\)|\(\+?61\)|\+?61|\(0[1-9]\)|0[1-9])?( ?-?[0-9]){7,9}$/,
  phone:
    /^(?!(\d{2}-\d{2}-\d{4}))(\+?\(61\)|\(\+?61\)|\+?61|\(0[2-9]\)|0[1-9])?( ?-?[0-9]){7,9}$/,

  dob: /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]|(?:Jan|Mar|May|Jul|Aug|Oct|Dec)))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1-9]|1[0-2]|(?:Jan|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec))\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)(?:0?2|(?:Feb))\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9]|(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec))|(?:1[0-2]|(?:Oct|Nov|Dec)))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})/i,
  // name: /[Hh]ello\s|[Ww]elcome\s|[Hh]i\s|[Mm]y\s[Nn]ame|Nice\sto|meet\syou|[Mm][rs]{1,2}\s/,
  masterCard:
    /^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/,
  visaCard: /^4[0-9]{12}(?:[0-9]{3})?$/,
  amexCard: /^3[47][0-9]{13}$/,
  piiname: /<[^>]{0,200}>/, // Personal names should be warp with bracket, so Regex can identify whether it is a PII.
};

// Default behaviour for generic click components to be track, even without analytics isEnabled.
export const whiteListPIIComponent = /^datePicker$/;

// White List Field name, check field name contains these word.
export const whitelistFieldName = /(?:start Date|StartDate)/i;
